module.exports = __webpack_public_path__ + "d791e42e95c335b32760150c6521ead4.mp4";